import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ActionsBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import {
  defaultButtonState,
  hoverButtonState,
} from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/buttonStates";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import { sizing } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/sizing";
import {
  ContentProp,
  DesignProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Button",
  version: 1,
  nameI18n: "builder_ui.block_type.button",
  category: [ActionsBlock],
  isHidden: true,
  props: {
    text: {
      name: "Text",
      nameI18n: "builder_ui.prop_type.text",
      category: [ContentProp],
      prop: "other",
      type: "string",
    },
    href: {
      name: "Link",
      nameI18n: "builder_ui.prop_type.link",
      category: [ContentProp],
      prop: "other",
      type: "string",
    },
    target: {
      name: "Target",
      nameI18n: "builder_ui.prop_type.target",
      category: [ContentProp],
      prop: "other",
      type: "select",
      defaultValue: "_self",
      options: [
        {
          label: "Self",
          labelI18n: "builder_ui.prop_type.target_types.self",
          value: "_self",
        },
        {
          label: "Blank",
          labelI18n: "builder_ui.prop_type.target_types.blank",
          value: "_blank",
        },
      ],
    },
    buttonType: {
      name: "Button Type",
      nameI18n: "builder_ui.prop_type.button_type",
      category: [DesignProp],
      prop: "other",
      type: "select",
      defaultValue: "secondaryButton",
      options: [
        {
          label: "Primary",
          labelI18n: "builder_ui.prop_type.button_type.primary",
          value: "primaryButton",
        },
        {
          label: "Secondary",
          labelI18n: "builder_ui.prop_type.button_type.secondary",
          value: "secondaryButton",
        },
        {
          label: "Custom",
          labelI18n: "builder_ui.prop_type.button_type.custom",
          value: "customButton",
        },
      ],
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles",
      category: [DesignProp],
      prop: "custom",
      type: "button",
      attributes: {
        default: {
          ...defaultButtonState,
          defaultValue: {
            backgroundColor: {
              ...defaultButtonState.defaultValue.backgroundColor,
              defaultValue: defaultStyles.default.backgroundColor,
            },
            borderColor: {
              ...defaultButtonState.defaultValue.borderColor,
              defaultValue: defaultStyles.default.borderColor,
            },
            borderRadius: {
              ...defaultButtonState.defaultValue.borderRadius,
              defaultValue: defaultStyles.default.borderRadius,
            },
            borderWidth: {
              ...defaultButtonState.defaultValue.borderWidth,
              defaultValue: defaultStyles.default.borderWidth,
            },
            color: {
              ...defaultButtonState.defaultValue.color,
              defaultValue: defaultStyles.default.color,
            },
            fontSize: {
              ...defaultButtonState.defaultValue.fontSize,
              defaultValue: defaultStyles.default.fontSize,
            },
            fontStyle: {
              ...defaultButtonState.defaultValue.fontStyle,
              defaultValue: defaultStyles.default.fontStyle,
            },
            fontWeight: {
              ...defaultButtonState.defaultValue.fontWeight,
              defaultValue: defaultStyles.default.fontWeight,
            },
            lineHeight: {
              ...defaultButtonState.defaultValue.lineHeight,
              defaultValue: defaultStyles.default.lineHeight,
            },
            textAlign: {
              ...defaultButtonState.defaultValue.textAlign,
              defaultValue: defaultStyles.default.textAlign,
            },
            textDecoration: {
              ...defaultButtonState.defaultValue.textDecoration,
              defaultValue: defaultStyles.default.textDecoration,
            },
            textTransform: {
              ...defaultButtonState.defaultValue.textTransform,
              defaultValue: defaultStyles.default.textTransform,
            },
          },
        },
        hover: {
          ...hoverButtonState,
          defaultValue: {
            backgroundColor: {
              ...hoverButtonState.defaultValue.backgroundColor,
              defaultValue: defaultStyles.hover.backgroundColor,
            },
            borderColor: {
              ...hoverButtonState.defaultValue.borderColor,
              defaultValue: defaultStyles.hover.borderColor,
            },
            borderRadius: {
              ...hoverButtonState.defaultValue.borderRadius,
              defaultValue: defaultStyles.hover.borderRadius,
            },
            borderWidth: {
              ...hoverButtonState.defaultValue.borderWidth,
              defaultValue: defaultStyles.hover.borderWidth,
            },
            color: {
              ...hoverButtonState.defaultValue.color,
              defaultValue: defaultStyles.hover.color,
            },
            fontSize: {
              ...hoverButtonState.defaultValue.fontSize,
              defaultValue: defaultStyles.hover.fontSize,
            },
            fontStyle: {
              ...hoverButtonState.defaultValue.fontStyle,
              defaultValue: defaultStyles.hover.fontStyle,
            },
            fontWeight: {
              ...hoverButtonState.defaultValue.fontWeight,
              defaultValue: defaultStyles.hover.fontWeight,
            },
            lineHeight: {
              ...hoverButtonState.defaultValue.lineHeight,
              defaultValue: defaultStyles.hover.lineHeight,
            },
            textAlign: {
              ...hoverButtonState.defaultValue.textAlign,
              defaultValue: defaultStyles.hover.textAlign,
            },
            textDecoration: {
              ...hoverButtonState.defaultValue.textDecoration,
              defaultValue: defaultStyles.hover.textDecoration,
            },
            textTransform: {
              ...hoverButtonState.defaultValue.textTransform,
              defaultValue: defaultStyles.hover.textTransform,
            },
          },
        },
        sizing: {
          ...sizing,
          defaultValue: defaultStyles.sizing,
        },
        margin: {
          ...margin,
          defaultValue: defaultStyles.margin,
        },
        padding: {
          ...padding,
          defaultValue: defaultStyles.padding,
        },
      },
    },
  },
};
